<template>
  <div>
    <b-field :label="items.label" :type="items.color" :message="items.message">
      <b-input
        :name="items.name"
        :type="items.type"
        :value="items.value"
        :maxlength="items.maxlength"
        :placeholder="items.placeholder"
        :width="items.width"
        :style="items.style"
      >
      </b-input>
    </b-field>
  </div>
</template>

<script>
import log from "loglevel";

export default {
  name: "Textbox",
  props: {
    items: {}
  },
  data() {
    return {};
  },
  created: function() {
    log.warn(1);
  },

  methods: {}
};
</script>
